import _ from 'lodash'
import Vue from 'vue'
import Vuex from 'vuex'

const store = new Vuex.Store({
    state: {},
    getters: {
        message: state => sid => _.get(state, `${sid}.message`, null),
        detail: state => sid => _.get(state, `${sid}.detail`, null),
        has: state => (sid, field) => _.has(_.get(state, `${sid}.errors`, {}), field),
        first: state => (sid, field) => _.first(_.get(state, `${sid}.errors`, {})[field] || [])
    },
    mutations: {
        reset (state, payload) {
            if (payload.sid) {
                Vue.delete(state, payload.sid)
            } else {
                _.each(state, (value, sid) => {
                    Vue.delete(state, sid)
                })
            }
        },

        set (state, payload) {
            Vue.set(state, payload.sid, payload.data)
        },

        forgive (state, payload) {
            if (_.has(state, payload.sid)) {
                Vue.delete(state[payload.sid].errors, payload.field)

                if (_.size(state[payload.sid].errors) < 1) {
                    Vue.delete(state, payload.sid)
                }
            }
        }
    }
})

const messages = {}

class Validator extends Vue {
    install (Vue, options) {
        Vue.prototype.$validator = this
    }

    reset (sid = null) {
        store.commit('reset', { sid })
    }

    state () {
        return store.state
    }

    set (data, sid = null) {
        store.commit('set', {
            sid: sid || '__DEFAULT__',
            data: {
                message: data.message,
                detail: data.detail,
                errors: _.transform(data.errors || [], (result, value, key) => {
                    result[key] = _.map(value, string => {
                        if (_.has(messages, sid || '__DEFAULT__') && _.isString(messages[sid][string])) {
                            string = messages[sid][string]
                        }

                        return string
                    })
                })
            }
        })

        this.$emit('set')
    }

    messages (msgs, sid = null) {
        messages[sid || '__DEFAULT__'] = msgs
    }

    getMessages () {
        return messages
    }

    has (field, sid = null) {
        return store.getters.has(sid || '__DEFAULT__', field)
    }

    first (field, sid = null) {
        return store.getters.first(sid || '__DEFAULT__', field)
    }

    forgive (field, sid = null) {
        return store.commit('forgive', {
            sid: sid || '__DEFAULT__',
            field
        })
    }

    message (sid = null) {
        return store.getters.message(sid || '__DEFAULT__')
    }

    detail (sid = null) {
        return store.getters.detail(sid || '__DEFAULT__')
    }
}

export default new Validator()
